import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestFragment = {
  __typename?: 'Contact';
  id: string;
  householdId: string;
  firstName: string;
  lastName: string;
  prefix?: string | null;
  suffix?: string | null;
  email?: string | null;
  legacyAddressString?: string | null;
  household?: {
    __typename?: 'ContactHousehold';
    id: string;
    displayName?: string | null;
    address?: {
      __typename?: 'ContactAddress';
      id: string;
      address1: string;
      address2?: string | null;
      country: string;
      countryCode: string;
      region: string;
      city: string;
      postalCode: string;
      validated: boolean;
    } | null;
  } | null;
  phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber'; id: string; number: string } | null> | null;
};

export type GetContactsByIdsGuestListQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type GetContactsByIdsGuestListQuery = {
  __typename?: 'Query';
  getContactsByIds?: Array<{
    __typename?: 'Contact';
    id: string;
    householdId: string;
    firstName: string;
    lastName: string;
    prefix?: string | null;
    suffix?: string | null;
    email?: string | null;
    legacyAddressString?: string | null;
    household?: {
      __typename?: 'ContactHousehold';
      id: string;
      displayName?: string | null;
      address?: {
        __typename?: 'ContactAddress';
        id: string;
        address1: string;
        address2?: string | null;
        country: string;
        countryCode: string;
        region: string;
        city: string;
        postalCode: string;
        validated: boolean;
      } | null;
    } | null;
    phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber'; id: string; number: string } | null> | null;
  } | null> | null;
};

export type GetContactCollectionByEventIdOrCreateOneQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetContactCollectionByEventIdOrCreateOneQuery = {
  __typename?: 'Query';
  getContactCollectionByEventIdOrCreateOne?: { __typename?: 'ContactCollection'; id: string } | null;
};

export type CreateContactsWithoutTagsGuestListMutationVariables = Types.Exact<{
  data: Array<Types.ContactInputWithoutTags> | Types.ContactInputWithoutTags;
}>;

export type CreateContactsWithoutTagsGuestListMutation = {
  __typename?: 'Mutation';
  createContactsWithoutTags: Array<{
    __typename?: 'Contact';
    id: string;
    householdId: string;
    firstName: string;
    lastName: string;
    prefix?: string | null;
    suffix?: string | null;
    email?: string | null;
    legacyAddressString?: string | null;
    household?: {
      __typename?: 'ContactHousehold';
      id: string;
      displayName?: string | null;
      address?: {
        __typename?: 'ContactAddress';
        id: string;
        address1: string;
        address2?: string | null;
        country: string;
        countryCode: string;
        region: string;
        city: string;
        postalCode: string;
        validated: boolean;
      } | null;
    } | null;
    phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber'; id: string; number: string } | null> | null;
  }>;
};

export type UpdateContactGuestListMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  data: Types.ContactInput;
}>;

export type UpdateContactGuestListMutation = {
  __typename?: 'Mutation';
  updateContact: {
    __typename?: 'Contact';
    id: string;
    householdId: string;
    firstName: string;
    lastName: string;
    prefix?: string | null;
    suffix?: string | null;
    email?: string | null;
    legacyAddressString?: string | null;
    household?: {
      __typename?: 'ContactHousehold';
      id: string;
      displayName?: string | null;
      address?: {
        __typename?: 'ContactAddress';
        id: string;
        address1: string;
        address2?: string | null;
        country: string;
        countryCode: string;
        region: string;
        city: string;
        postalCode: string;
        validated: boolean;
      } | null;
    } | null;
    phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber'; id: string; number: string } | null> | null;
  };
};

export type DeleteContactsByContactIdsGuestListMutationVariables = Types.Exact<{
  contactIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  firebaseEventId?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type DeleteContactsByContactIdsGuestListMutation = { __typename?: 'Mutation'; deleteContactsByContactIds: Array<{ __typename?: 'Contact'; id: string }> };

export type AttendanceByEventIdQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type AttendanceByEventIdQuery = {
  __typename?: 'Query';
  attendanceByEventId: Array<{ __typename: 'Attendance'; id: string; guestKey: string; attendanceState: Types.AttendanceState; createdAt: any }>;
};

export type SetAttendanceByGuestKeyMutationVariables = Types.Exact<{
  input: Types.AttendanceInput;
}>;

export type SetAttendanceByGuestKeyMutation = {
  __typename?: 'Mutation';
  setAttendanceByGuestKey: { __typename: 'Attendance'; id: string; guestKey: string; attendanceState: Types.AttendanceState; createdAt: any };
};

export const GuestFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Guest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'household' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'legacyAddressString' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetContactsByIdsGuestListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactsByIdsGuestList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactsByIds' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'ids' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Guest' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Guest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'household' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'legacyAddressString' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactsByIdsGuestListQuery__
 *
 * To run a query within a React component, call `useGetContactsByIdsGuestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByIdsGuestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByIdsGuestListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetContactsByIdsGuestListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>) {
  return ApolloReactHooks.useQuery<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>(GetContactsByIdsGuestListDocument, baseOptions);
}
export function useGetContactsByIdsGuestListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>(GetContactsByIdsGuestListDocument, baseOptions);
}
export type GetContactsByIdsGuestListQueryHookResult = ReturnType<typeof useGetContactsByIdsGuestListQuery>;
export type GetContactsByIdsGuestListLazyQueryHookResult = ReturnType<typeof useGetContactsByIdsGuestListLazyQuery>;
export type GetContactsByIdsGuestListQueryResult = Apollo.QueryResult<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>;
export const GetContactCollectionByEventIdOrCreateOneDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactCollectionByEventIdOrCreateOne' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactCollectionByEventIdOrCreateOne' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactCollectionByEventIdOrCreateOneQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByEventIdOrCreateOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByEventIdOrCreateOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByEventIdOrCreateOneQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetContactCollectionByEventIdOrCreateOneQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>(
    GetContactCollectionByEventIdOrCreateOneDocument,
    baseOptions,
  );
}
export function useGetContactCollectionByEventIdOrCreateOneLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>(
    GetContactCollectionByEventIdOrCreateOneDocument,
    baseOptions,
  );
}
export type GetContactCollectionByEventIdOrCreateOneQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdOrCreateOneQuery>;
export type GetContactCollectionByEventIdOrCreateOneLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdOrCreateOneLazyQuery>;
export type GetContactCollectionByEventIdOrCreateOneQueryResult = Apollo.QueryResult<
  GetContactCollectionByEventIdOrCreateOneQuery,
  GetContactCollectionByEventIdOrCreateOneQueryVariables
>;
export const CreateContactsWithoutTagsGuestListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContactsWithoutTagsGuestList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInputWithoutTags' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContactsWithoutTags' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Guest' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Guest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'household' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'legacyAddressString' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateContactsWithoutTagsGuestListMutationFn = Apollo.MutationFunction<CreateContactsWithoutTagsGuestListMutation, CreateContactsWithoutTagsGuestListMutationVariables>;

/**
 * __useCreateContactsWithoutTagsGuestListMutation__
 *
 * To run a mutation, you first call `useCreateContactsWithoutTagsGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactsWithoutTagsGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactsWithoutTagsGuestListMutation, { data, loading, error }] = useCreateContactsWithoutTagsGuestListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactsWithoutTagsGuestListMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactsWithoutTagsGuestListMutation, CreateContactsWithoutTagsGuestListMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateContactsWithoutTagsGuestListMutation, CreateContactsWithoutTagsGuestListMutationVariables>(
    CreateContactsWithoutTagsGuestListDocument,
    baseOptions,
  );
}
export type CreateContactsWithoutTagsGuestListMutationHookResult = ReturnType<typeof useCreateContactsWithoutTagsGuestListMutation>;
export type CreateContactsWithoutTagsGuestListMutationResult = Apollo.MutationResult<CreateContactsWithoutTagsGuestListMutation>;
export type CreateContactsWithoutTagsGuestListMutationOptions = Apollo.BaseMutationOptions<
  CreateContactsWithoutTagsGuestListMutation,
  CreateContactsWithoutTagsGuestListMutationVariables
>;
export const UpdateContactGuestListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactGuestList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Guest' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Guest' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'household' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'legacyAddressString' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateContactGuestListMutationFn = Apollo.MutationFunction<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>;

/**
 * __useUpdateContactGuestListMutation__
 *
 * To run a mutation, you first call `useUpdateContactGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactGuestListMutation, { data, loading, error }] = useUpdateContactGuestListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactGuestListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>(UpdateContactGuestListDocument, baseOptions);
}
export type UpdateContactGuestListMutationHookResult = ReturnType<typeof useUpdateContactGuestListMutation>;
export type UpdateContactGuestListMutationResult = Apollo.MutationResult<UpdateContactGuestListMutation>;
export type UpdateContactGuestListMutationOptions = Apollo.BaseMutationOptions<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>;
export const DeleteContactsByContactIdsGuestListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteContactsByContactIdsGuestList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firebaseEventId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteContactsByContactIds' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'contactIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'contactIds' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'firebaseEventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'firebaseEventId' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteContactsByContactIdsGuestListMutationFn = Apollo.MutationFunction<
  DeleteContactsByContactIdsGuestListMutation,
  DeleteContactsByContactIdsGuestListMutationVariables
>;

/**
 * __useDeleteContactsByContactIdsGuestListMutation__
 *
 * To run a mutation, you first call `useDeleteContactsByContactIdsGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsByContactIdsGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsByContactIdsGuestListMutation, { data, loading, error }] = useDeleteContactsByContactIdsGuestListMutation({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *      firebaseEventId: // value for 'firebaseEventId'
 *   },
 * });
 */
export function useDeleteContactsByContactIdsGuestListMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactsByContactIdsGuestListMutation, DeleteContactsByContactIdsGuestListMutationVariables>,
) {
  return ApolloReactHooks.useMutation<DeleteContactsByContactIdsGuestListMutation, DeleteContactsByContactIdsGuestListMutationVariables>(
    DeleteContactsByContactIdsGuestListDocument,
    baseOptions,
  );
}
export type DeleteContactsByContactIdsGuestListMutationHookResult = ReturnType<typeof useDeleteContactsByContactIdsGuestListMutation>;
export type DeleteContactsByContactIdsGuestListMutationResult = Apollo.MutationResult<DeleteContactsByContactIdsGuestListMutation>;
export type DeleteContactsByContactIdsGuestListMutationOptions = Apollo.BaseMutationOptions<
  DeleteContactsByContactIdsGuestListMutation,
  DeleteContactsByContactIdsGuestListMutationVariables
>;
export const AttendanceByEventIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AttendanceByEventId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attendanceByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAttendanceByEventIdQuery__
 *
 * To run a query within a React component, call `useAttendanceByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAttendanceByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>) {
  return ApolloReactHooks.useQuery<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>(AttendanceByEventIdDocument, baseOptions);
}
export function useAttendanceByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>(AttendanceByEventIdDocument, baseOptions);
}
export type AttendanceByEventIdQueryHookResult = ReturnType<typeof useAttendanceByEventIdQuery>;
export type AttendanceByEventIdLazyQueryHookResult = ReturnType<typeof useAttendanceByEventIdLazyQuery>;
export type AttendanceByEventIdQueryResult = Apollo.QueryResult<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>;
export const SetAttendanceByGuestKeyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAttendanceByGuestKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendanceInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAttendanceByGuestKey' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetAttendanceByGuestKeyMutationFn = Apollo.MutationFunction<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>;

/**
 * __useSetAttendanceByGuestKeyMutation__
 *
 * To run a mutation, you first call `useSetAttendanceByGuestKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAttendanceByGuestKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAttendanceByGuestKeyMutation, { data, loading, error }] = useSetAttendanceByGuestKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAttendanceByGuestKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>) {
  return ApolloReactHooks.useMutation<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>(SetAttendanceByGuestKeyDocument, baseOptions);
}
export type SetAttendanceByGuestKeyMutationHookResult = ReturnType<typeof useSetAttendanceByGuestKeyMutation>;
export type SetAttendanceByGuestKeyMutationResult = Apollo.MutationResult<SetAttendanceByGuestKeyMutation>;
export type SetAttendanceByGuestKeyMutationOptions = Apollo.BaseMutationOptions<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>;
